export default __webpack_public_path__ + "static/media/dashboard_logo.6023d69e.png";